<template>
	<div class="customer_drawer">
		<drawerHeader v-bind="headerInfo" :logo="logo" v-on="$listeners"></drawerHeader>
		<sky-tabs
			v-model="tabValue"
			:tabList="tabList"
			class="custclass-tab"
			:customClass="false"
		></sky-tabs>
		<div class="component">
			<el-scrollbar style="height: 100%">
				<component
					:is="tabValue"
					:isCollapse="false"
					:id="headerInfo.id"
					:garbageFlag="headerInfo.garbageFlag"
					:followupName="headerInfo.followupName"
					:type="type"
					v-bind="$attrs"
					:sourceType="headerInfo.sourceType"
				></component>
			
			<!-- <custActionItems
				class="bottom"
				:garbageFlag="headerInfo.garbageFlag"
				:getData="getData"
				@changeName="changeName"
				v-bind="$attrs"
			></custActionItems> -->
		</el-scrollbar>
		</div>
	</div>
</template>
<script>
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
import drawerHeader from '@/components/chat/drawer-header.vue';
import customerEdit from '@/components/chat/customer-edit.vue';
import custContactInfo from '@/components/crm/customer/cust-contactInfo.vue'; //联系人列表
import attrInfo from '@/components/chat/components/attrInfo.vue';
import custActionItems from '@/components/chat/fold/cust-action-items.vue';
// 全部客户和我的客户可编辑
// 公海客户不可编辑
export default {
	props: {
		id: {
			type: String,
		},
		headerInfo: {
			type: Object,
		},
		logo:null
	},
	watch: {
		id: {
			handler(val) {
				this.tabValue = 'attrInfo';
			},
			deep: true,
			immediate: true,
		},
	},
	data() {
		let that = this;
		return {
			tabValue: 'attrInfo',
			tabList: [
				{
					label: '归因',
					name: 'attrInfo',
				},
				{
					label: '信息',
					name: 'customerEdit',
				},
				{
					label: '联系人',
					name: 'custContactInfo',
				},
			],
			visible: false,
			getData: {
				customerId: that.headerInfo.id,
				customerName: that.headerInfo.nickname,
			},
			sumId: that.headerInfo.id,
			type: 2, //类型：客户为2
		};
	},
	methods: {
		changeName(val = 0) {
			this.garbageFlag = val;
			this.tabValue = 'custContactInfo';
			this.$nextTick(() => {
				this.tabValue = 'attrInfo';
			});
		},
		skip() {
			if (this.garbageFlag == 1) {
				this.$router.push({
					name: 'publicCustomerDetails',
					query: {
						id: this.sumId,
						type: 2,
					},
				});
			} else {
				this.$router.push({
					name: this.source == 0 ? 'customerDetails_all' : 'customerDetails',
					query: {
						id: this.sumId,
						type: 3,
					},
				});
			}
		},
		changeGarbageFlag(val) {
			this.garbageFlag = val;
		},
	},
	components: {
		drawerHeader,
		customerEdit,
		skyTabs,
		custContactInfo,
		attrInfo,
		custActionItems,
	},
};
</script>
<style lang="scss" scoped>
.sky-tabs {
	padding: 0px !important;
}
.custclass-tab {
	::v-deep  .el-tabs__header {
		margin: 0px !important;
	}
	::v-deep .el-tabs__item {
		padding-left: 20px !important;
	}
}
.customer_drawer {
	width: 380px;
	height: 100%;
	display: flex;
	flex-direction: column;
	::v-deep .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	::v-deep  .el-tabs {
		.el-tabs__header {
			margin: 0;
		}

		.el-tabs__item {
			padding: 0 10px;
		}

		.el-tabs__active-bar {
			height: 3px;
		}

		.el-tabs__nav-wrap {
			background-color: #fafafa;
			padding: 0 5px;
		}

		.el-tabs__nav-wrap::after {
			height: 1px;
		}
	}
}
.component {
	height: calc(100vh - 370px);
	/* display: flex;
	flex-direction: column;
	.context {
		flex: 1;
	} */
}
</style>
